<template>
    <div>
        <div class="header">
            Device
        </div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        placeholder="Search device"
                        @keyup.enter="getDevicePagination()"
                        solo>
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        color="primary"
                        outlined
                        @click="getDevicePagination()"
                        class="search-button">
                        search
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="permissionCreate"
                    color="primary"
                    height="40px"
                    @click="createDevice()">
                    + Create Device
                </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                :headers="isZktGateway ? zktHeaders : headers"
                :items="devices"
                @page-count="pageCount = $event"
                :page.sync="page"
                :options.sync="options"
                :server-items-length="totalDevices"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                        <div class="action">
                            <v-icon
                                v-if="permissionUpdate"
                                class="mr-2"
                                @click="updateDevice(item)">
                                edit
                            </v-icon>
                            <v-icon
                                v-if="permissionDelete"
                                class="mr-2"
                                @click="openModalDelete(item)">
                                delete
                            </v-icon>
                        </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <device-form-modal
            ref="deviceModal"
            :mode="operationMode"
            :updateDeviceId="updateDeviceId"
            :isZktGateway="isZktGateway"
            @success-created="getDevicePagination()"
            @success-updated="getDevicePagination()"
            @close-modal="closeModal()"/>

        <delete-modal
            ref="modalDeleteDevice"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import permissionConstant from '@/constants/permissions.js'
import DeviceFormModal from '@/components/modal/DeviceFormModal.vue'
import DeleteModal from '@/components/modal/DeleteModal'
export default {
    name: 'Device',

    components: {
        DeviceFormModal,
        DeleteModal
    },

    data () {
        return {
            search: '',
            headers: [
                { text: 'Device Name', value: 'name', width: '15%' },
                { text: 'Serial Number', value: 'serial_number', width: '20%' },
                { text: 'Branch Name', value: 'branch_name', width: '15%' },
                { text: 'End Point', value: 'endpoint', width: '35%' },
                { text: 'Action', value: 'action', sortable: false, align: 'center' }
            ],
            zktHeaders: [
                { text: 'Device Name', value: 'name', width: '18%' },
                { text: 'Branch Name', value: 'branch_name', width: '20%' },
                { text: 'Group Code', value: 'group_code', width: '12%' },
                { text: 'Access Key', value: 'access_key', width: '35%' },
                { text: 'Action', value: 'action', sortable: false, align: 'center' }
            ],
            pageCount: 1,
            page: 1,
            options: {},
            devices: [],
            totalDevices: 0,
            loading: false,
            operationMode: '',
            updateDeviceId: null,
            deleteForm: {
                header: 'Delete Device',
                content: '',
                path: ''
            },
            permissionCreate: false,
            permissionUpdate: false,
            permissionDelete: false
        }
    },

    methods: {

        async getDevicePagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `devices?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.devices = res.data.data
                this.totalDevices = res.data.total
                this.loading = false
            }
        },

        closeModal () {
            this.operationMode = ''
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.device.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.device.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.device.delete)
        },

        createDevice () {
            this.operationMode = 'create'
            this.$refs.deviceModal.dialog = true
        },

        async updateDevice (device) {
            this.operationMode = 'update'
            this.updateDeviceId = device.id
            this.$refs.deviceModal.dialog = true
        },

        async deleteSuccess () {
            await this.getDevicePagination()
            this.$notify({
                title: 'Congratulation',
                text: 'Device is deleted.',
                type: 'success'
            })
        },

        async openModalDelete (device) {
            this.deleteForm.content = `Are you sure you want to delete "${device.name}" device ?`
            this.deleteForm.path = `device/delete/${device.id}`
            this.$refs.modalDeleteDevice.dialog = true
        }
    },

    computed: {
        isZktGateway () {
            return process.env.VUE_APP_ZKT_GATEWAY === 'true'
        }
    },

    mounted () {
        this.checkPermission()
    },

    watch: {
        options: {
            async handler () {
                await this.getDevicePagination()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    width: 50%;
    display: flex;
    .search-input {
        width: 340px;
    }
    .search-button {
        height: 45px;
    }
}
</style>
